import React, { useEffect } from "react";
import Newsletter from "../Components/Newsletter";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import QuestBannerSlider from "../LabSoftware/QuestBannerSlider";
import "./PipelineProducts.css";

const PIPELINE_CARDS = [
  {
    id: "extended",
    title: "ClinTa HRP",
    icon: "fas fa-building",
    description: "The comprehensive ClinTa HRP (Hospital Resource Planning) is a real hospital ERP that seamlessly integrates every department along with respective operations of the hospital, ensuring every detailed report is instantly available to the management right at the time of data entry.",
  },
  {
    id: "special",
    title: "ClinTa Special",
    icon: "fas fa-stethoscope",
    description: "Experience the power of specialization at your fingertips. ClinTa Special is uniquely designed to meet the specific needs of diverse clinical specialties, including Oncology, ENT, and Endoscopy. It provides tailored, cutting-edge features for your practice area.",
  },
  {
    id: "advanced",
    title: "ClinTa Advanced",
    icon: "fas fa-flask",
    description: "ClinTa Advanced is engineered to handle the complexities of clinical research, offering a comprehensive set of features designed to simplify research workflows. Effortlessly manage participants, gather data, and utilize advanced analysis tools for powerful insights.",
  },
];

function PipelineProducts() {
  useEffect(() => {
    document.title = "Quest :: D-Right Technologies";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <div className="main">
        <QuestBannerSlider />

        <section className="pipeline-products-section our-blog-section ptb-100 gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-10 mb-3" style={{ textAlign: "center" }}>
                <h2 className="web mb-3">Transforming Hospitals Digitally</h2>
                <p>
                  Revolutionizing Healthcare with Advanced Software! We're developing a complete Hospital Information Management System (HIMS) for end-to-end hospital solutions. Stay tuned for comprehensive programs for every clinical specialty and dedicated software for clinical research.
                </p>
              </div>
            </div>
            <div className="pipeline-products-cards">
              {PIPELINE_CARDS.map((card) => (
                <div key={card.id} className="pipeline-product-card">
                  <div className="card-header-row">
                    <div className="card-icon">
                      <i className={card.icon} />
                    </div>
                    <h4 className="card-title">{card.title}</h4>
                  </div>
                  <p className="card-text">{card.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

      </div>

      <Newsletter />
      <Footer />
    </>
  );
}

export default PipelineProducts;
